import React from 'react'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { ContentfulProvider } from '@pcln/contentful-components'
import { FeatureProvider } from '@pcln/feature-components'
import Layout from '../components/Layout'
import { CustomContext, PageProps, QueryString } from '../types'
import Home from '../components/Home'
import '../styles/main.scss'
import profileData from '../utils/profile-data'
import AppBanner, { getPropsForAppBanner } from '../components/AppBanner'
import BANNER_TEXT_VALUES from '../components/AppBanner/constants'
import { HOME_PRODUCT_TYPE } from '../constants/products'
import { shouldHideAppBanner } from '../components/AppBanner/utils'
import getContent from '../utils/get-content'
import prePopulateHotelValues from '../utils/prepop-helper'

const appBannerValues = BANNER_TEXT_VALUES[HOME_PRODUCT_TYPE]

const Homepage: NextPage<PageProps> = ({
  contentful,
  headerHTML,
  footerHTML,
  bootstrapData
}) => {
  const { query } = useRouter()
  const shouldShowAppBanner = !shouldHideAppBanner(
    bootstrapData,
    query as QueryString
  )
  return (
    <FeatureProvider features={bootstrapData.featureToggles}>
      <ContentfulProvider contentful={contentful}>
        {shouldShowAppBanner ? (
          <AppBanner
            {...{
              ...getPropsForAppBanner(bootstrapData),
              ...appBannerValues
            }}
          />
        ) : null}
        <Layout
          headerHTML={headerHTML}
          footerHTML={footerHTML}
          partner={bootstrapData.partner || null}
        >
          <Home />
        </Layout>
      </ContentfulProvider>
    </FeatureProvider>
  )
}

export async function getServerSideProps(ctx: CustomContext) {
  const { req, res } = ctx
  const {
    cookies: { dmc }
  } = req
  const {
    locals: {
      bootstrapData,
      bootstrapSETI,
      headerHTML = '',
      footerHTML = '',
      webstats: { clientGUID: cguid }
    }
  } = res

  const mostRecentBooking = await profileData({ dmc, cguid })
  const { featureToggles } = bootstrapData
  let contentful = null
  if (featureToggles?.siteExperience?.contentfulEnabled) {
    contentful = await getContent(
      {
        contentTypeId: 'pageHome',
        plfCode: 'PCLN',
        depth: 5
      },
      'Homepage::getServerSideProps: Failed to fetch Contentful data'
    )
  }

  const hotelPrePopData = await prePopulateHotelValues(
    ctx.req.query as QueryString
  )
  const prePopData = hotelPrePopData ? { hotels: hotelPrePopData } : null

  return {
    props: {
      contentful,
      headerHTML,
      footerHTML,
      bootstrapData: {
        ...bootstrapData,
        mostRecentBooking,
        ...(prePopData && { prePopData })
      },
      bootstrapSETI
    }
  }
}

export default Homepage
